<app-croud-taxe #croudTaxe></app-croud-taxe>
<div class=" p-0">
    <div class="card-body p-0">
    <div *ngIf="isLoading" class="loading">Chargement...</div>
    <div *ngIf="!isLoading && error" class="error">{{ error }}</div>
    <div *ngIf="!isLoading && !error">
      <table *ngIf="TaxeList.length > 0" class="table align-middle">
              <thead class="custom-thead">
          <tr>
            <th class="paddd">Nom</th>
            <th class="paddd">Contexte</th>
            <th class="paddd">Valeur</th>
            <th class="paddd">Taxes appliquées sur les produits</th>
            <th class="paddd">Appliqué sur tous les documents</th>
            <th class="paddd">État</th>
            <th class="paddd">Action</th>
          </tr>
        </thead>
        <tbody style="justify-content: space-between">
          <tr *ngFor="let taxe of TaxeList; let i = index">
            <td style="padding-left: 18px">{{ taxe.nom }}</td>
            <td>{{ getUtilisationLabel(taxe) }}</td>
            <td>{{ getTaxeValue(taxe) }}</td>
            <td>
              <i
                [attr.data-feather]="(taxe.applique_tva || taxe.applique_a_la_tva) ? 'x' : (taxe.taxe_applique_sur_produits ? 'check' : 'x')"
                class="feather-icon icon-15 mr-75"
                [ngClass]="{
                  'icon-success': !(taxe.applique_tva || taxe.applique_a_la_tva) && taxe.taxe_applique_sur_produits,
                  'icon-danger': (taxe.applique_tva || taxe.applique_a_la_tva) || !taxe.taxe_applique_sur_produits
                }"
                [style.color]="(!(taxe.applique_tva || taxe.applique_a_la_tva) && taxe.taxe_applique_sur_produits) ? 'rgba(40, 199, 111, 1)' : 'rgba(255, 76, 81, 1)'"
              ></i>
            </td>
            <td style="vertical-align: baseline">
              <div class="custom-control custom-switch custom-control-success">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'switchTousDoc' + i"
                  [checked]="isAppliqueSurTousDocument(taxe)"
                  [disabled]="updatingTousDocTaxeId === taxe.id"
                  (change)="onAppliqueSurTousDocumentChange(taxe, $any($event.target).checked)"
                />
                <label class="custom-control-label" [for]="'switchTousDoc' + i"></label>
              </div>
            </td>
            <td  style="vertical-align: baseline">
              <div class="custom-control custom-switch custom-control-success">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'customSwitch' + i"
                  [checked]="taxe.statut"
                  (change)="toggleTaxe(taxe, $event)"
                />
                <label class="custom-control-label" [for]="'customSwitch' + i"></label>
              </div>
            </td>
            <td class="text-center">
              <button class="btn btn-primary btn-sm" (click)="editTaxe(taxe)">
                <i data-feather="edit" class="feather-icon icon-15"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #modalLG let-modal>
  <div class="modal-header" style="background-color: transparent;" aria-label="Modal Header">
    <button type="button" class="close" (click)="cancelModal()" aria-label="Close Modal">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body p-0" tabindex="0" ngbAutofocus>
    <div *ngIf="modalType === 'etat'">
      <div class="text-center" style="margin-bottom: 64px;margin-top: 30px">
        <h4>{{ desiredStatut ? 'Activation' : 'Désactivation' }} Taxe</h4>
        <p class="mb-2">{{ confirmationMessage }}</p>
        <form #etatForm="ngForm" (ngSubmit)="onSubmit(etatForm)">
          <div class="mt-2">
            <button class="btn btn-primary mr-2" type="submit" [disabled]="isLoading">Confirmer</button>
            <button class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()" [disabled]="isLoading">Annuler</button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="modalType === 'ajouter' || modalType === 'update'" style="padding: 30px 64px 64px 64px">
      <div class="text-center " role="alert" aria-live="polite">
        <p class="fw-bold titre">{{ modalType === 'ajouter' ? 'Ajoutez des taxes' : 'Modifiez des taxes' }}</p>
        <p class="sous-titre">Veuillez renseigner les informations requises pour enregistrer une taxe.</p>
      </div>
      <form #taxeForm="ngForm" (ngSubmit)="onSubmit(taxeForm)" class="modal-taxe-form" style="padding-left: 14px">
        <div class="row" >
          <!-- Nom -->
          <div class="p-0" style="margin-right: 12px">
            <label for="taxeNom" class="form-label">Nom <span class="text-danger" aria-hidden="true">*</span></label>
            <input
              type="text"
              class="form-control"
              id="taxeNom"
              name="nom"
              [(ngModel)]="TaxeData.nom"
              placeholder="Entrez le nom"
              aria-required="true"
              required
              style="width: 374px;"
              maxlength="200"
              #nomInput="ngModel"
              [ngClass]="{'is-invalid': nomInput.invalid && (nomInput.dirty || nomInput.touched || taxeForm.submitted)}"
            >
            <div *ngIf="nomInput.invalid && (nomInput.dirty || nomInput.touched || taxeForm.submitted)" class="invalid-feedback">
              <span *ngIf="nomInput.errors?.required">Le nom est requis.</span>
              <span *ngIf="nomInput.errors?.maxlength">Le nom ne doit pas dépasser 200 caractères.</span>
            </div>
          </div>
          <!-- Label -->
          <div class="p-0" style="margin-left: 12px">
            <label for="taxeLabel" class="form-label">Libellé <span class="text-danger" aria-hidden="true">*</span></label>
            <input
              type="text"
              class="form-control"
              id="taxeLabel"
              name="label"
              [(ngModel)]="TaxeData.label"
              placeholder="Entrez le libellé"
              aria-required="true"
              required
              style="width: 374px;"
              maxlength="200"
              #labelInput="ngModel"
              [ngClass]="{'is-invalid': labelInput.invalid && (labelInput.dirty || labelInput.touched || taxeForm.submitted)}"
            >
            <div *ngIf="labelInput.invalid && (labelInput.dirty || labelInput.touched || taxeForm.submitted)" class="invalid-feedback">
              <span *ngIf="labelInput.errors?.required">Le libellé est requis.</span>
              <span *ngIf="labelInput.errors?.maxlength">Le libellé ne doit pas dépasser 200 caractères.</span>
            </div>
          </div>
          <!-- Valeur et type -->
          <div class="col-12 form-group" style="padding: 0 0.5rem; margin-bottom: 0.5rem;">
            <div class="d-flex align-items-center flex-wrap gap-1" role="group" aria-label="Options de valeur et type" style="margin-top: 24px">
              <!-- + / - -->
              <div class="radio-group d-flex align-items-center gap-2">
                <label class="radio-container">
                  <input type="radio" class="form-check-input" name="type" value="+" [(ngModel)]="TaxeData.type" required #typeInput="ngModel">
                  <span class="checkmark"></span>
                  <span>+</span>
                </label>
                <label class="radio-container">
                  <input type="radio" class="form-check-input" name="type" value="-" [(ngModel)]="TaxeData.type" required #typeInput="ngModel">
                  <span class="checkmark"></span>
                  <span>-</span>
                </label>
              </div>
              <div *ngIf="typeInput.invalid && (typeInput.dirty || typeInput.touched || taxeForm.submitted)" class="invalid-feedback">
                <span *ngIf="typeInput.errors?.required">Le type est requis.</span>
              </div>
              <!-- Input + / - boutons -->
              <div class="input-group align-items-center mb-0" style="width: 166px; margin-left: 4rem;" aria-label="Ajustement de la valeur">
                <button
                  class="btn p-0 d-flex justify-content-center align-items-center del-button"
                  type="button"
                  style="width: 38px; height: 38px; background-color: rgba(255, 76, 81, 0.16);"
                  (click)="decrementValue()"
                  aria-label="Décrémenter"
                  [disabled]="TaxeData.valeur <= 0"
                >
                  -
                </button>
                <input
                  type="number"
                  class="form-control text-center"
                  name="valeur"
                  [(ngModel)]="TaxeData.valeur"
                  id="taxeValue"
                  min="0"
                  max="999999999" 
                  step="0.1"
                  pattern="[0-9]+(\.[0-9]{1,2})?"
                  maxlength="10"
                  style="width: 90px; height: 38px;"
                  aria-label="Valeur de la taxe"
                  required
                  #valeurInput="ngModel"
                  [ngClass]="{'is-invalid': valeurInput.invalid && (valeurInput.dirty || valeurInput.touched || taxeForm.submitted)}"
                  (ngModelChange)="onValueChange()"
                >
                <button
                  class="btn p-0 d-flex justify-content-center align-items-center add-button"
                  type="button"
                  style="width: 38px; height: 38px; background-color: rgba(255, 76, 81, 0.16);"
                  (click)="incrementValue()"
                  aria-label="Incrémenter"
                >
                  +
                </button>
                <div *ngIf="valeurInput.invalid && (valeurInput.dirty || valeurInput.touched || taxeForm.submitted)" class="invalid-feedback">
                  <span *ngIf="valeurInput.errors?.required">La valeur est requise.</span>
                  <span *ngIf="valeurInput.errors?.min">La valeur doit être supérieure ou égale à 0.</span>
                  <span *ngIf="valeurInput.errors?.pattern">Veuillez entrer un nombre valide (ex. 0.5).</span>
                  <span *ngIf="isValueTooLong()">La valeur ne doit pas dépasser 10 caractères.</span>
                </div>
              </div>
              <!-- Pourcentage / Fixe -->
              <div class="radio-group d-flex align-items-center ms-2" style="margin-left: 5rem;" role="group" aria-label="Type de valeur">
                <label class="radio-container">
                  <input type="radio" class="form-check-input" name="valeur_pourcentage" [value]="true" [(ngModel)]="TaxeData.valeur_pourcentage" (ngModelChange)="TaxeData.valeur_fixe = !TaxeData.valeur_pourcentage" required #valeurPourcentageInput="ngModel">
                  <span class="checkmark"></span>
                  <span>Pourcentage</span>
                </label>
                <label class="radio-container">
                  <input type="radio" class="form-check-input" name="valeur_pourcentage" [value]="false" [(ngModel)]="TaxeData.valeur_pourcentage" (ngModelChange)="TaxeData.valeur_fixe = !TaxeData.valeur_pourcentage" required #valeurPourcentageInput="ngModel">
                  <span class="checkmark"></span>
                  <span>Fixe</span>
                </label>
              </div>
              <div *ngIf="valeurPourcentageInput.invalid && (valeurPourcentageInput.dirty || valeurPourcentageInput.touched || taxeForm.submitted)" class="invalid-feedback">
                <span *ngIf="valeurPourcentageInput.errors?.required">Le type de valeur est requis.</span>
              </div>
            </div>
          </div>
            <div class="col-12 form-group p-0" style="margin: 24px 0 0 0" role="group" aria-label="Options d'utilisation">
                <label class="text-dark" style="margin-bottom: 8px">Utilisation <span class="text-danger" aria-hidden="true">*</span></label>
                <br>
                <div class="radio-group d-flex align-items-center flex-wrap gap-3">
                  <label class="radio-container">
                    <input type="radio" class="form-check-input" name="utilisationModeRadio" value="tous" [(ngModel)]="utilisationMode" required #utilisationModeNg="ngModel">
                    <span class="checkmark"></span>
                    <span>Tous</span>
                  </label>
                  <label class="radio-container">
                    <input type="radio" class="form-check-input" name="utilisationModeRadio" value="ventes" [(ngModel)]="utilisationMode" required>
                    <span class="checkmark"></span>
                    <span>Ventes</span>
                  </label>
                  <label class="radio-container">
                    <input type="radio" class="form-check-input" name="utilisationModeRadio" value="achat" [(ngModel)]="utilisationMode" required>
                    <span class="checkmark"></span>
                    <span>Achat</span>
                  </label>
                </div>
                <div *ngIf="utilisationModeNg.invalid && (utilisationModeNg.dirty || utilisationModeNg.touched || taxeForm.submitted)" class="invalid-feedback d-block">
                    <span *ngIf="utilisationModeNg.errors?.required">L'utilisation est requise.</span>
                </div>
            </div>
          <div class="col-12 form-group p-0" style="margin: 24px 0 0 0">
            <div class="form-check checkbox-container">
              <input
                class="form-check-input"
                type="checkbox"
                id="appliqueALaTva"
                name="applique_tva"
                [(ngModel)]="TaxeData.applique_tva"
                (ngModelChange)="onAppliqueTvaChange()"
              >
              <label class="form-check-label text-dark" for="appliqueALaTva">Appliqué à la TVA</label>
            </div>
          </div>
          <div *ngIf="!TaxeData.applique_tva" class="col-12 form-group p-0" style="margin: 24px 0 0 0" role="group" aria-label="Options d'application">
            <label class="text-dark" style="margin-bottom: 8px">Application <span class="text-danger" aria-hidden="true">*</span></label>
            <br>
            <div class="radio-group d-flex align-items-center gap-3">
              <label class="radio-container">
                <input type="radio" class="form-check-input" name="application" value="avant_tva" (ngModelChange)="TaxeData.applique_avant_tva = $event === 'avant_tva'; TaxeData.applique_apres_tva = $event === 'apres_tva'" [ngModel]="TaxeData.applique_avant_tva ? 'avant_tva' : (TaxeData.applique_apres_tva ? 'apres_tva' : null)" required #applicationInput="ngModel">
                <span class="checkmark"></span>
                <span>Avant la TVA</span>
              </label>
              <label class="radio-container">
                <input type="radio" class="form-check-input" name="application" value="apres_tva" (ngModelChange)="TaxeData.applique_avant_tva = $event === 'avant_tva'; TaxeData.applique_apres_tva = $event === 'apres_tva'" [ngModel]="TaxeData.applique_apres_tva ? 'apres_tva' : (TaxeData.applique_avant_tva ? 'avant_tva' : null)" required #applicationInput="ngModel">
                <span class="checkmark"></span>
                <span>Après la TVA</span>
              </label>
            </div>
            <div *ngIf="applicationInput.invalid && (applicationInput.dirty || applicationInput.touched || taxeForm.submitted)" class="invalid-feedback">
              <span *ngIf="applicationInput.errors?.required">L'application est requise.</span>
            </div>
          </div>

          <!-- Checkbox (masqué si "Appliqué à la TVA" est coché) -->
          <div *ngIf="!TaxeData.applique_tva" class="col-12" style="padding: 24px 0 0 0">
            <div class="form-check checkbox-container">
              <input
                class="form-check-input"
                type="checkbox"
                id="taxeAppliqueSurProduits"
                name="taxe_applique_sur_produits"
                [(ngModel)]="TaxeData.taxe_applique_sur_produits"
              >
              <label class="form-check-label" for="taxeAppliqueSurProduits">Appliquer la taxe aux produits</label>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0 p-0" style="padding-top: 31px;" role="region" aria-label="Actions de validation">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="taxeForm.invalid || isLoading"
            aria-label="Valider les modifications"
          >
            <span>Valider</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Chargement...</span>
            </span>
          </button>
          <button
            type="button"
            class="btn btn-default"
            style="background-color: #80839029;"
            (click)="cancelModal()"
            [disabled]="isLoading"
            aria-label="Annuler les modifications"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
